import { fetch2, get, baseURL, type ResponseType } from "./api";

import {
  // AllowFloatingBallDomains,
  // StorageKeyMap,
  ReportTargetMap,
} from "@/config";

import { FinderTrackEvents } from "@/views/main/finder/hooks/useTrackEvents";

// 获取用户信息
export function getUserProfile(params: any = {}) {
  // return new Promise(function (resolve) {
  //   setTimeout(() => {
  //     resolve({
  //       code: 200,
  //       msg: "success",
  //       data: {
  //         id: "123",
  //         name: "张三",
  //         email: "zhangsan@example.com",
  //       },
  //     });
  //   }, 1000);
  // });
  return fetch2(baseURL + "/api/auth/userProfile/me", params, undefined, true);
}
// 获取用户信息
export function linkedinLoginAuth(params: any = {}) {
  return fetch2(baseURL + "/api/login/oauth2/authorization/linkedin", params);
}

// 获取salesforce oauth地址
export function oauthSalesforce(params: any = {}) {
  return fetch2(baseURL + "/api/oauth2/authorization/salesforce", params);
}

// 获取GoogleSheets oauth地址
export function oauthGoogleSheets(params: any = {}) {
  return fetch2(baseURL + "/api/oauth2/authorization/google", params);
}

// 获取notion oauth地址
export function oauthNotion(params: any = {}) {
  return fetch2(baseURL + "/api/oauth2/authorization/notion", params);
}

// 获取 Hubspot oauth地址
export function oauthHubspot(params: any = {}) {
  return fetch2(baseURL + "/api/oauth2/authorization/hubspot", params);
}

// 获取 Zoho oauth地址
export function oauthZoho(params: any = {}) {
  return fetch2(baseURL + "/api/oauth2/authorization/zoho", params);
}

// 谷歌登录
export function oauthGoogle(
  params: {
    auth_type: "google_bind" | "google_auth" | "google_sheet";
    business_url?: string;
  } = {
    auth_type: "google_sheet",
  }
) {
  let uri = `/api/login/oauth2/authorization/google?auth_type=${params.auth_type}`;
  if (params.business_url) uri = `${uri}&business_url=${params.business_url}`;
  return fetch2(baseURL + uri);
}

// 谷歌登录
export function getUserPermission(params: any = {}, query: any = {}) {
  const search = new URLSearchParams(query);
  let uri = "/api/user/info";
  // @ts-ignore 忽略类型检查
  if (search.size) uri = `${uri}?${search.toString()}`;
  return fetch2(baseURL + uri, params);
}

export type UserApiInfoType = {
  remainCredits: number;
  usedCredits: number;
  token: string;
  hasClaimedFreeApiCredits: boolean;
};

export type ApiPricesType = {
  unitPriceA: number;
  unitPriceB: number;
  unitPriceC: number;
};

export function getUserApiInfo(params: any = {}) {
  return get<UserApiInfoType>(baseURL + "/api/user/apiInfo", params);
}

export function claimFreeApiCredits(params: any = {}) {
  return fetch2(baseURL + "/api/user/claimFreeApiCredits", params);
}

export function getApiPrices(params: any = {}) {
  return get<ApiPricesType>(baseURL + "/api/pay/getApiPrices", params);
}

export function createApiCheckoutSession(params: {
  quantity: number;
  successUrl: string;
  cancelUrl: string;
}) {
  return fetch2<string>(baseURL + "/api/pay/createApiCheckoutSession", params);
}

// 获取套餐列表
export function getPackageList(params: any = {}) {
  return fetch2<any[]>(baseURL + "/api/package/list", params);
}

// 订阅信息
export function getSubscriptionInfo(params: any = {}) {
  return fetch2(baseURL + "/api/subscription/info", params);
}

export type SubscriptionCancelInfoType = {
  nextPeriodRenew: boolean;
  unsub50PercentOffPriceNextPeriod?: number | string;
};

// 获取取消订阅相关信息
export function getSubscriptionCancelInfo(params: any = {}) {
  return fetch2<SubscriptionCancelInfoType>(
    baseURL + "/api/subscription/cancel/info",
    params,
  );
}

export type SubscriptionRenewStatusType = {
  renewFail: boolean;
  renewFailMissingPaymentMethod: boolean;
};

// 查询订阅续费失败状态
export function getSubscriptionRenewStatus(params: any = {}) {
  // return {
  //   code: 200,
  //   data:{
  //     renewFail: false,
  //     renewFailMissingPaymentMethod: true,
  //   }
  // }
  return get<SubscriptionRenewStatusType>(
    baseURL + "/api/subscription/renewStatus",
    params,
  );
}

export type QueryCreditCostsType = {
  findEmailCredits: number;
  findPhoneCredits: number;
  findKpCredits: number;
  syncCredits: number;
};

// 获取用户各类操作的积分消耗单价
export async function queryCreditCosts(
  params: any = {},
): Promise<ResponseType<QueryCreditCostsType>> {
  // return {
  //   code: 200,
  //   msg: "success",
  //   data: {
  //     findEmailCredits: 100,
  //     findPhoneCredits: 200,
  //     findKpCredits: 50,
  //     syncCredits: 30,
  //   },
  // };
  return get<QueryCreditCostsType>(baseURL + "/api/user/queryCreditCosts", params);
}

export type UserEventStatsType = {
  findEmailCount: number;
  findPhoneCount: number;
  findEmployeesCount: number;
  unsubCouponUsed: boolean;
  unusedFeatures: Array<
    | "USER_FIND_EMAIL_REQUEST"
    | "USER_FIND_PHONE_REQUEST"
    | "USER_FIND_COMPANY_EMPLOYEES"
    | "USER_FIND_COMPANY_REQUEST"
    | string
  >;
};

// 获取用户查找行为统计，用于订阅管理弹窗展示已使用功能和未尝试功能
export function getUserEventStats(params: any = {} , loading: boolean = false) {
  // return {
  //   code: 200,
  //   data: {
  //     unusedFeatures: [
  //       "USER_FIND_EMAIL_REQUEST",
  //       "USER_FIND_PHONE_REQUEST",
  //       "USER_FIND_COMPANY_EMPLOYEES",
  //       "USER_FIND_COMPANY_REQUEST"
  //     ],
  //     findEmailCount: 1,
  //     findPhoneCount: 2,
  //     findEmployeesCount: 3,
  //     unsubCouponUsed: false,
  //   },
  // }; 
  return get<UserEventStatsType>(baseURL + "/api/user/event/stats", params, {
    loading,
  });
}

// 提交用户取消订阅原因
export function submitSubscriptionCancelReason(params: { reason: string }) {
  return fetch2(baseURL + "/api/user/subscription/cancel/reason", params);
}

// 取消当前用户订阅
export function cancelSubscription(params: any = {}) {
  return fetch2(baseURL + "/api/subscription/cancel", params);
}

// 获取当前积分使用情况
export type CompanyEmployeesPointsType = {
  countStartTime: number;
  countEndTime: number;
  historyMonthlyConsumedPoints: number;
  remainingMonthlyPoints: number;
  remainingPermanentPoints: number;
  historyPermanentConsumedPoints: number;
  isFreePackage: boolean;
  packageName: string;
  remainingPoints: number;
};
export function getCompanyEmployeesPoints(params: any = {}) {
  return get<CompanyEmployeesPointsType>(
    baseURL + "/api/company/employees/points",
    params
  );
}

// 获取同步的历史记录
export function getSyncHistory(params: any = {}) {
  return fetch2(baseURL + "/api/dataSyncHistory/page", params);
}
// 积分变更列表
export function getCreditsChangeList(params: any = {}) {
  return fetch2(baseURL + "/api/credits/changeList", params);
}

export function getVersionInfo(params: any = {}) {
  // return Promise.resolve({
  //   code: 200,
  //   data: {
  //     title: "LeadContact",
  //     desc:"LeadContact",
  //     closeable:false,
  //     btn:{
  //       text:"立即更新",
  //       link:"https://portal.linkedcrm.ai/#account"
  //     }
  //   },
  //   msg: "success",
  // });
  return fetch2(baseURL + "/api/system/version", params);
}

// 获得waitlist数据
export function getWaitlist() {
  return fetch2(baseURL + "/api/settings/getWaitlist");
}

// 获得waitlist数据
export function joinWaitlist(params: any = {}) {
  return fetch2(baseURL + "/api/settings/joinWaitlist", params);
}
// const AllowFloatingBallDomains = ["www.linkedin.com"];
type SettingsType = {
  floatingBall?: boolean;
};

export type UserPreferenceType = {
  connectMessageStatus?: "Auto" | "Pending" | "Manual" | "";
  floatBallShowStatus?:
    | "SHOW_WITH_BLACKLIST"
    | "ONLY_ON_LINKEDIN"
    | "HIDE_ALWAYS";
  floatBallBlacklist?: string[];
  cardVisible?: boolean;
  emailFindMode?: "Auto" | "Manual" | "Pending" | "";
  crmSyncMode?: "Auto" | "Manual";
  floatBallVisible?: boolean;
  googleDetailVisible?: boolean;
};

export function getUserPreference(
  params: {
    targetUrl?: string;
  } = {}
) {
  return fetch2<UserPreferenceType>(baseURL + "/api/user/preference", params);
}

export function updateUserPreference(params: UserPreferenceType) {
  return fetch2(baseURL + "/api/user/preference/update", params);
}
export function addBlacklistItem(params: { targetUrl: string }) {
  return fetch2(baseURL + "/api/settings/blacklist/add", params);
}
export function deleteBlacklistItem(params: any = {}) {
  return fetch2(baseURL + "/api/settings/blacklist/del", params);
}
// export function getUserSettings(params: { domain?: string } = {}) {
//   // return Promise.resolve({
//   //   code: 200,
//   //   data: {
//   //     settings: {
//   //       floatingBall: true,
//   //       summarize: true,
//   //     },
//   //   },
//   // });
//   return storage
//     .get([FloatingBallType, AllowFloatingBallDomains])
//     .then((res) => {
//       const floatingBall =
//         res[FloatingBallType] === undefined ||
//         res[FloatingBallType] === FloatingBallTypeMap.All ||
//         (res[FloatingBallType] === FloatingBallTypeMap.Includes &&
//           res[AllowFloatingBallDomains] &&
//           res[AllowFloatingBallDomains].includes(
//             params.domain || window.location.host
//           ));
//       return {
//         code: 200,
//         data: {
//           settings: {
//             floatingBall: floatingBall,
//             // summarize: res[StorageKeyMap.SkipPlatforms] !== 1,
//           },
//         },
//       };
//     });
// }

// export function updateUserSettings(
//   params: {
//     floatingBall?: boolean;
//     domain?: string;
//   } = {}
// ) {
//   if (params.floatingBall === false) {
//     return storage.set({
//       [FloatingBallType]: FloatingBallTypeMap.Nothing,
//     });
//   } else {
//     if (params.domain) {
//       return storage.get([AllowFloatingBallDomains]).then((res) => {
//         const allows = res[AllowFloatingBallDomains] || [];
//         if (!allows.includes(params.domain)) {
//           allows.push(params.domain);
//         }
//         return storage.set({
//           [FloatingBallType]: FloatingBallTypeMap.Includes,
//           [AllowFloatingBallDomains]: allows,
//         });
//       });
//     } else {
//       return storage.set({
//         [FloatingBallType]: FloatingBallTypeMap.All,
//       });
//     }
//   }
// }

export function getMessageList(params: any = {}) {
  // return response;
  // return Promise.resolve({
  //   code: 200,
  //   msg: "success",
  //   data: {
  //     messageList: [
  //       {
  //         body: "Don't miss out on LeadContact Special Offer.\nTap now to get your gift! 👉",
  //         callback: "xx",
  //         icon: "",
  //         image:
  //           "https://framerusercontent.com/images/uZnC4Hz3j0orVQ7boWylzihnGtc.png",
  //         timeout: 10,
  //         title: "🎁 Only $1.90 to Unlock!",
  //         url: "https://portal.linkedcrm.ai/#account",
  //       },
  //       {
  //         title: "New Features! 🚀",
  //         body: "打开linkedin",
  //         url: "http://www.linkedin.com",
  //       },
  //     ],
  //   },
  // });

  return fetch2<{
    userId: string;
    messageList: {
      title: string;
      body: string;
      icon: string;
      image: string;
      url: string;
    }[];
  }>(baseURL + "/api/message/getList", params);
}

// 0为 chrome网页推送，1为悬浮球弹窗, 2为侧边栏弹窗
export function getMessageCount(params: { type: 0 | 1 | 2 }) {
  return fetch2<number>(
    baseURL + "/api/message/countNotificationByType",
    params
  );
}

export function reportEvent(params: {
  event?: "click" | "show" | "hide";
  target?:
    | (typeof ReportTargetMap)[keyof typeof ReportTargetMap]
    | (typeof FinderTrackEvents)[keyof typeof FinderTrackEvents];
  // [key: string]: any;
}) {
  const { event = "click", target, ...otherParams } = params;
  const page = window.location.href;
  return fetch2(baseURL + "/api/user/track", {
    event,
    target,
    page,
    ...otherParams,
  });
}

// 获取批量操作剩余资源
export function queryUserResources(params: any = {}) {
  return get(
    baseURL + "/api/contact/batch/resources",
    params,
    undefined,
    false
  );
}
// 卸载插件
export function userUninstall(params: any = {}) {
  return fetch2(baseURL + "/api/user/uninstall", params);
}
// 获取通知
export function getNotificationByType(params: any = {}) {
  return fetch2(baseURL + "/api/message/getNotificationByType", params);
}

// 绑定领英
export function bindLinkedinProfile() {
  return fetch2(
    baseURL + "/api/user/bind_linkedin_proflie",
    undefined,
    undefined,
    true
  );
}

export function addReward(params: { eventType: "INSTALL_PLUGIN" }) {
  return fetch2(baseURL + "/api/ads/add_reward", params);
}

export function identifyUser() {
  return fetch2(
    baseURL + "/api/auth/chatbase/getHashedId",
    null,
    { needCache: true },
    false
  );
}

// 获取当前用户的实验详情
export function getExperimentInfoApi(params: any = {}) {
  return fetch2(baseURL + "/api/ab_test/get_experiment_info", params);
}

// 获取消息
export function getAlert(params: any = {}) {
  return get(baseURL + "/api/alert/get", params, undefined, true);
}

// 确认消息展出
export function confirmAlertShow(params: any = {}) {
  return fetch2(baseURL + "/api/alert/confirm/show", params);
}

/** 获取国家名称 */
export function getPlacesOfOrigin(params: any = {}) {
  return get(baseURL + "/api/places-of-origin/get", params);
}

export type PluginsInfoType = {
  newPluginInstalled: boolean;
  oldPluginInstalled: boolean;
};

export function getPluginsInfo() {
  return get<PluginsInfoType>(baseURL + "/api/website/plugins/info");
}
